import { useState, useRef } from 'react'
import { useDisclosure } from '@chakra-ui/react'
import { updateDoc, doc } from 'firebase/firestore'
import { AdditionalDetails } from '../../../../../../types/FirestoreUser'
import { getEffectiveServices } from '../../../../../../utils/firebaseServiceContext'

const useDeleteOccupation = (
  uid: string,
  additionalDetails: Partial<AdditionalDetails>,
  setAdditionalDetails: React.Dispatch<
    React.SetStateAction<Partial<AdditionalDetails>>
  >
) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef<any>()
  const [occupationToDelete, setOccupationToDelete] = useState<string | null>(
    null
  )

  const handleDeleteOccupation = (id: string) => {
    setOccupationToDelete(id)
    onOpen()
  }

  const confirmDeleteOccupation = async () => {
    if (occupationToDelete) {
      const docRef = doc(getEffectiveServices().firestore, 'users', uid)

      try {
        const newArray = (additionalDetails.occupations || []).filter(
          (occupation: any) => occupation.id !== occupationToDelete
        )

        await updateDoc(docRef, {
          'additionalDetails.occupations': newArray,
        })

        setAdditionalDetails((prevDetails: any) => ({
          ...prevDetails,
          occupations: newArray,
        }))

        setOccupationToDelete(null)
        onClose()
      } catch (error) {
        console.error('Error deleting occupation:', error)
      }
    }
  }

  return {
    isOpen,
    onOpen,
    onClose,
    cancelRef,
    handleDeleteOccupation,
    confirmDeleteOccupation,
  }
}

export default useDeleteOccupation
